<template>
  <div
    class="total-price-shadow bg-background-neutral-secondary sticky bottom-0 -ml-4 flex w-[calc(100%+32px)] items-center justify-between rounded-t-xl px-4 py-3"
  >
    <div class="space-y-1.5">
      <p
        v-price="totalPrice"
        class="text-text-neutral-primary text-base font-bold"
      ></p>
      <p class="text-text-neutral-primary text-xs">
        {{ $t('ancillaries.baggages.totalPrice') }}
      </p>
    </div>
    <FreeButton
      type="button"
      size="sm"
      class="green-main-button w-1/2"
      @click="emit('onAncillariesSave')"
    >
      {{ $t('general.save') }}
    </FreeButton>
  </div>
</template>

<script setup lang="ts">
  import { FreeButton } from 'freedom-shared';

  const emit = defineEmits<{ onAncillariesSave: [] }>();
  defineProps<{ totalPrice: number }>();
</script>

<style scoped>
  .total-price-shadow {
    box-shadow: 0px 2px 20px 0px #0000000d;
  }
</style>
